import { appointments as AT } from './AT';
import { appointments as CZ } from './CZ';
import { appointments as HR } from './HR';
import { appointments as HU } from './HU';
import { appointments as RO } from './RO';
import { appointments as SK } from './SK';
import { appointments as RS } from './RS';

export const featureMap = {
    AT,
    CZ,
    HR,
    HU,
    RO,
    SK,
    RS,
};
